import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { DataProvider } from "./contexts/DataContext";
import Main from './layouts/Main';
import NotFound from "./pages/NotFound";

import publicRoutes from "./routes/PublicRoutes";
import protectedRoutes from "./routes/ProtectedRoutes";

import PatientMedicalRecord from './components/Doctor/PatientMedicalRecord';
import PrescriptionForm from './components/Doctor/PrescriptionForm';
import MyPatients from './components/Doctor/MyPatients';
import Agenda from './components/Doctor/Agenda';
import Reports from './components/Doctor/Reports';

import UserManagement from './components/Admin/UserManagement';
import Statistics from './components/Admin/Statistics';
import FinancialReports from './components/Admin/FinancialReports';
import SystemSettings from './components/Admin/SystemSettings';

import ProfilePage from './pages/ProfilePage';
import HelpPage from './pages/HelpPage';
import SettingsPage from './pages/SettingsPage';

import Signin from "./pages/Signin";
import Signin2 from "./pages/Signin2";

// styles
import "./assets/css/remixicon.css";
import "./scss/style.scss";

// set skin on load
window.addEventListener("load", function () {
  let skinMode = localStorage.getItem("skin-mode");
  let HTMLTag = document.querySelector("html");

  if (skinMode) {
    HTMLTag.setAttribute("data-skin", skinMode);
  }
});

export default function App() {
  return (
    <AuthProvider>
      <DataProvider>
        <BrowserRouter>
          <Routes>

            {/* 🔥 REDIRECTION DE / */}
            <Route path="/" element={<Navigate to="/login" replace />} />

            {/* 🔓 ROUTES PUBLIQUES */}
           
            <Route path="/signin2" element={<Signin2 />} />

            {publicRoutes.map((route, index) => (
              <Route
                key={index}
                path={route.path}
                element={route.element}
              />
            ))}

            {/* 🔒 ROUTES PROTÉGÉES */}
            <Route path="/" element={<Main />}>

              {protectedRoutes.map((route, index) => (
                <Route
                  key={index}
                  path={route.path}
                  element={route.element}
                />
              ))}

              {/* DOCTOR */}
              <Route path="doctor/patient-record/:patientId" element={<PatientMedicalRecord />} />
              <Route path="doctor/prescribe/:patientId" element={<PrescriptionForm />} />
              <Route path="doctor/patients" element={<MyPatients />} />
              <Route path="doctor/agenda" element={<Agenda />} />
              <Route path="doctor/reports" element={<Reports />} />

              {/* ADMIN */}
              <Route path="admin/users" element={<UserManagement />} />
              <Route path="admin/statistics" element={<Statistics />} />
              <Route path="admin/reports" element={<FinancialReports />} />
              <Route path="admin/settings" element={<SystemSettings />} />

              {/* GENERAL */}
              <Route path="pages/profile" element={<ProfilePage />} />
              <Route path="pages/help" element={<HelpPage />} />
              <Route path="pages/settings" element={<SettingsPage />} />

            </Route>

            {/* 404 */}
            <Route path="*" element={<NotFound />} />

          </Routes>
        </BrowserRouter>
      </DataProvider>
    </AuthProvider>
  );
}